module.exports = __webpack_public_path__ + "static/media/btn_fechar.c9c131b0.svg";